import { FaSort, FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";

const TableBasic = ({ head, children, onSort, sortConfig }) => {

    const getSortIndicator = (key) => {
        if (!sortConfig || sortConfig.key !== key) return null;
        const direction = (sortConfig.direction || '').toString().toLowerCase();
        return direction === 'asc' ? (<FaSortAmountUp />) : (<FaSortAmountDown />);
    };

    const handleSort = (item) => {
        if (!item.sortable || !onSort || !item.key) return;
        onSort(item.key);
    };

    return (
        <div className="table-wrap mb-3">
            <table className="w-full text-sm leading-snug">
                <thead className="border-b border-hairline bg-canvas text-xs text-muted dark:border-white/10 dark:bg-tile-1 dark:text-white/70">
                    <tr>
                        {
                            head.map((item, index) => (
                                <th
                                    key={index}
                                    scope="col"
                                    className={`whitespace-nowrap px-4 py-3 text-${item.align || 'left'} font-medium ${
                                        item.sticky
                                            ? 'sticky right-0 z-20 bg-canvas dark:bg-tile-1 md:static'
                                            : ''
                                    }`}
                                >
                                    {item.sortable ? (
                                        <button
                                            type="button"
                                            className="flex select-none items-center gap-1.5 text-link"
                                            onClick={() => handleSort(item)}
                                        >
                                            <span>{item.name}</span>
                                            <span className="text-[9px] opacity-60">{getSortIndicator(item.key) || <FaSort />}</span>
                                        </button>
                                    ) : (
                                        <span>{item.name}</span>
                                    )}
                                </th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody className="divide-y divide-hairline bg-canvas text-body dark:divide-white/10 dark:bg-tile-1 dark:text-white [&_td:not([colspan])]:!px-4 [&_td:not([colspan])]:!py-3 [&_td:not([colspan])]:!text-sm [&_button]:!p-1.5 [&_svg]:!h-3.5 [&_svg]:!w-3.5 [&_small]:!mt-0 [&_small]:!text-xs">
                    {children}
                </tbody>
            </table>
        </div>
    );
}

export default TableBasic;
